































import { Vue, Component } from 'vue-property-decorator'

@Component({
  name: 'c-delete-key-dialog'
})
export default class DeleteKeyDialog extends Vue {
  dialog: boolean = false
  resolve: any = null
  reject: any = null

  open (): Promise<void> {
    this.dialog = true

    return new Promise((resolve, reject) => {
      this.resolve = resolve
      this.reject = reject
    })
  }

  del (): void {
    this.resolve(true)
    this.dialog = false
  }

  cancel (): void {
    this.resolve(false)
    this.dialog = false
  }

  provide () {
    return {
      agree: (this as any).agree,
      cancel: this.cancel
    }
  }
}
